export default __webpack_public_path__ + "static/media/my_request.f25cf6c4.svg";